<template>
  <div>
    <DxPopup
      v-if="gajiPeriodeData"
      :visible="popupRefreshAllGajiVisible"
      title="Konfirmasi Setting Penggajian"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :height="650"
      :width="550"
    >
      <div class="dx-fieldset">
        <div class="dx-field">
          <div class="dx-field-label">Skema Gaji Pokok</div>
          <div class="dx-field-value">
            <DxSelectBox
              :dataSource="gajiPokokSkemaSource"
              valueExpr="id"
              displayExpr="nama"
              :searchEnabled="true"
              searchExpr="nama"
              search-mode="startswith"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="gajiPeriodeData.gaji_pokok_skema_id"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxSelectBox>
          </div>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">
          Skema penggajian untuk masing-masing status pegawai
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Skema Gaji Direktur Utama</div>
          <div class="dx-field-value">
            <DxSelectBox
              :dataSource="gajiSkemaDirutSource"
              valueExpr="id"
              displayExpr="nama"
              :searchEnabled="true"
              searchExpr="nama"
              search-mode="startswith"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="gajiPeriodeData.gaji_skema_dirut_id"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxSelectBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Skema Gaji Direktur Umum</div>
          <div class="dx-field-value">
            <DxSelectBox
              :dataSource="gajiSkemaDirumSource"
              valueExpr="id"
              displayExpr="nama"
              :searchEnabled="true"
              searchExpr="nama"
              search-mode="startswith"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="gajiPeriodeData.gaji_skema_dirum_id"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxSelectBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Skema Gaji Direktur Teknik</div>
          <div class="dx-field-value">
            <DxSelectBox
              :dataSource="gajiSkemaDirtekSource"
              valueExpr="id"
              displayExpr="nama"
              :searchEnabled="true"
              searchExpr="nama"
              search-mode="startswith"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="gajiPeriodeData.gaji_skema_dirtek_id"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxSelectBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Skema Gaji Pegawai Tetap</div>
          <div class="dx-field-value">
            <DxSelectBox
              :dataSource="gajiSkemaTetapSource"
              valueExpr="id"
              displayExpr="nama"
              :searchEnabled="true"
              searchExpr="nama"
              search-mode="startswith"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="gajiPeriodeData.gaji_skema_tetap_id"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxSelectBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Skema Gaji Pegawai Capeg</div>
          <div class="dx-field-value">
            <DxSelectBox
              :dataSource="gajiSkemaCapegSource"
              valueExpr="id"
              displayExpr="nama"
              :searchEnabled="true"
              searchExpr="nama"
              search-mode="startswith"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="gajiPeriodeData.gaji_skema_capeg_id"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxSelectBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Skema Gaji Pekerja Honor</div>
          <div class="dx-field-value">
            <DxSelectBox
              :dataSource="gajiSkemaHonorSource"
              valueExpr="id"
              displayExpr="nama"
              :searchEnabled="true"
              searchExpr="nama"
              search-mode="startswith"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="gajiPeriodeData.gaji_skema_honor_id"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxSelectBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Skema Gaji Pekerja Kontrak</div>
          <div class="dx-field-value">
            <DxSelectBox
              :dataSource="gajiSkemaKontrakSource"
              valueExpr="id"
              displayExpr="nama"
              :searchEnabled="true"
              searchExpr="nama"
              search-mode="startswith"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="gajiPeriodeData.gaji_skema_kontrak_id"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxSelectBox>
          </div>
        </div>
      </div>

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptions"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="saveButtonOptions"
      />
    </DxPopup>

    <dx-popup
      :visible="loadingVisible"
      :title="loadingTitle"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </dx-popup>

    <dx-popup
      :visible="refreshDialogVisible"
      title="Konfirmasi Refresh Data Proyeksi"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="170"
    >
      <div>
        Refresh data untuk Proyeksi Gaji tahun {{ tahunProyeksi }}? Proses
        refresh akan membutuhkan waktu cukup lama (+- 5 menit).
      </div>
      <!-- <div class="buttons">
            <dx-button text="Cancel" @click="cancelDelete" />
            <dx-button text="Delete" @click="confirmDelete" />
          </div> -->
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptions"
      />
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="saveButtonOptionsKonfirm"
      />
    </dx-popup>

    <h2 class="content-block">
      Proyeksi_practice
      <span>
        <DxButton
          icon="refresh"
          :text="refreshButtonText"
          @click="refreshProyeksiDialog()"
          styling-mode="outlined"
          type="default"
        />
      </span>
    </h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <h5>Grafik Proyeksi</h5>
        <DxChart ref="refChart">
          <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
          <DxAdaptiveLayout :width="0" :height="0" />
          <DxSize :height="700" />
          <DxCommonSeriesSettings type="line" />
          <!-- <DxArgumentAxis > -->
          <DxLegend horizontal-alignment="center" vertical-alignment="bottom" />
          <DxExportChart :enabled="true" :printing-enabled="false" />
        </DxChart>
        <DxButton
          icon="export"
          text="Export Chart"
          @click="exportChart"
          :visible="false"
        />
        <h5>Detail Data Proyeksi</h5>

        <DxPivotGrid
          id="pivotGrid"
          ref="refPivot"
          :allow-sorting-by-summary="true"
          :allow-sorting="true"
          :allow-filtering="true"
          :allow-expand-all="true"
          :show-borders="true"
          :data-source="dataSourceTetap"
          @exporting="onExporting"
        >
          <DxFieldChooser :enabled="false" />
          <DxExport :enabled="true" />
        </DxPivotGrid>
      </div>
    </div>

    <div v-for="(perbandingan, index) in storePerbandingan" :key="index">
      <div class="content-block">
        <div class="dx-card responsive-paddings">
          <h3>{{ perbandingan.title }}</h3>

          <table class="table table-bordered table-hover table-responsive">
            <thead>
              <tr>
                <th>No</th>
                <th>Uraian</th>
                <th>{{ perbandingan.bulan1 }}</th>
                <th>{{ perbandingan.bulan2 }}</th>
                <th>Selisih</th>
                <th>Ket.</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(valKomponen, indexKomponen) in perbandingan.data"
                :key="indexKomponen"
              >
                <td>{{ indexKomponen + 1 }}</td>
                <td>{{ valKomponen.komponen }}</td>
                <td>{{ valKomponen.bulan1 }}</td>
                <td>{{ valKomponen.bulan2 }}</td>
                <td>{{ valKomponen.bulan2 - valKomponen.bulan1 }}</td>
                <!-- <td>{{ printKet(perbandingan.ket) }}</td> -->
                <td rowspan="9" v-if="printKetJustOnce(indexKomponen)">
                  <div
                    v-html="printKet(perbandingan.ket, perbandingan.title)"
                  ></div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>Total</td>
                <td>{{ perbandingan.total1 }}</td>
                <td>{{ perbandingan.total2 }}</td>
                <td>{{ perbandingan.total2 - perbandingan.total1 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.highlight-ket {
  background-color: #ffdfd3;
  font-weight: bold;
  display: inline-block; /* Make the div inline-block */
  margin-right: 5px; /* Add some right margin for spacing */
}
</style>

<script>
import can from "@/haspermission";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import DxSelectBox from "devextreme-vue/select-box";
import notify from "devextreme/ui/notify";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { DateTime } from "luxon";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import DxPivotGrid, {
  DxExport,
  DxFieldChooser,
} from "devextreme-vue/pivot-grid";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import {
  DxChart,
  DxAdaptiveLayout,
  DxCommonSeriesSettings,
  DxSize,
  DxTooltip,
  // DxArgumentAxis,
  DxLegend,
  DxExport as DxExportChart,
} from "devextreme-vue/chart";

import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { exportPivotGrid } from "devextreme/excel_exporter";
import DxButton from "devextreme-vue/button";
import { useGajiPokokSkemaStore } from "@/stores/GajiPokokSkemaStore";
import { useGajiSkemaDirutStore } from "@/stores/GajiSkemaDirutStore";
import { useGajiSkemaDirumStore } from "@/stores/GajiSkemaDirumStore";
import { useGajiSkemaDirtekStore } from "@/stores/GajiSkemaDirtekStore";
import { useGajiSkemaTetapStore } from "@/stores/GajiSkemaTetapStore";
import { useGajiSkemaCapegStore } from "@/stores/GajiSkemaCapegStore";
import { useGajiSkemaHonorStore } from "@/stores/GajiSkemaHonorStore";
import { useGajiSkemaKontrakStore } from "@/stores/GajiSkemaKontrakStore";

export default {
  components: {
    DxPivotGrid,
    DxFieldChooser,
    DxChart,
    DxAdaptiveLayout,
    DxCommonSeriesSettings,
    DxSize,
    DxTooltip,
    // DxArgumentAxis,
    DxLegend,
    DxExport,
    DxButton,
    DxExportChart,
    DxPopup,
    DxToolbarItem,
    DxSelectBox,
    DxValidator,
    DxRequiredRule,
  },
  setup() {
    const gajiPokokSkemaStore = useGajiPokokSkemaStore();
    const gajiSkemaDirutStore = useGajiSkemaDirutStore();
    const gajiSkemaDirumStore = useGajiSkemaDirumStore();
    const gajiSkemaDirtekStore = useGajiSkemaDirtekStore();
    const gajiSkemaTetapStore = useGajiSkemaTetapStore();
    const gajiSkemaCapegStore = useGajiSkemaCapegStore();
    const gajiSkemaHonorStore = useGajiSkemaHonorStore();
    const gajiSkemaKontrakStore = useGajiSkemaKontrakStore();

    return {
      gajiPokokSkemaStore,
      gajiSkemaDirutStore,
      gajiSkemaDirumStore,
      gajiSkemaDirtekStore,
      gajiSkemaTetapStore,
      gajiSkemaCapegStore,
      gajiSkemaHonorStore,
      gajiSkemaKontrakStore,
      can,
    };
  },

  data() {
    return {
      gajiPeriodeData: {
        gaji_pokok_skema_id: null, // Define gaji_pokok_skema_id with an initial value
        gaji_skema_dirut_id: null,
        gaji_skema_dirum_id: null,
        gaji_skema_dirtek_id: null,
        gaji_skema_tetap_id: null,
        gaji_skema_capeg_id: null,
        gaji_skema_honor_id: null,
        gaji_skema_kontrak_id: null,
        tgl: null,
      },
      popupRefreshAllGajiVisible: null,
      loadingVisible: false,
      loadingTitle: "Refresh Proyeksi Gaji...",
      tahunProyeksi: DateTime.local().year,
      refreshDialogVisible: false,
      cancelButtonOptions: {
        text: "Cancel",
        type: "danger",
        onClick: () => {
          console.log("cancelButtonOptions");
          this.refreshDialogVisible = false;
          this.popupRefreshAllGajiVisible = false;
        },
      },

      saveButtonOptions: {
        text: "Refresh Proyeksi",
        type: "default",
        onClick: () => {
          this.refreshDialogVisible = false;
          this.refreshProyeksi();
        },
      },
      saveButtonOptionsKonfirm: {
        text: "Refresh Proyeksi",
        type: "default",
        onClick: () => {
          this.refreshDialogVisible = false;
          this.popupRefreshAllGajiVisible = true;
        },
      },

      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      setting: "0",
      tabPanelIndex: 0,
      loop: false,
      animationEnabled: true,
      swipeEnabled: false,

      //---PIVOT
      storeTetap: null,
      storePerbandingan: null,
      dataSourceTetap: null,
      placeholderPegawaiSelectedPivot: [],
      pivotInstance: null,
      chartInstance: null,
      //---/PIVOT
    };
  },
  async mounted() {
    this.gajiPokokSkemaSource = await this.gajiPokokSkemaStore.get();
    this.gajiSkemaDirutSource = await this.gajiSkemaDirutStore.get();
    this.gajiSkemaDirumSource = await this.gajiSkemaDirumStore.get();
    this.gajiSkemaDirtekSource = await this.gajiSkemaDirtekStore.get();
    this.gajiSkemaTetapSource = await this.gajiSkemaTetapStore.get();
    this.gajiSkemaCapegSource = await this.gajiSkemaCapegStore.get();
    this.gajiSkemaHonorSource = await this.gajiSkemaHonorStore.get();
    this.gajiSkemaKontrakSource = await this.gajiSkemaKontrakStore.get();

    await this.fetchData();
    await this.fetchDataPerbandingan();

    // this.setDataStoreTetap();

    this.pivotInstance = this.$refs.refPivot.instance;
    this.chartInstance = this.$refs.refChart.instance;
    const self = this;

    this.pivotInstance.bindChart(this.chartInstance, {
      dataFieldsDisplayMode: "splitPanes",
      alternateDataFields: false,
      chartSettings: {
        type: "line",
      },
      processCell: function (cellData) {
        if (cellData.rowPath.length === 0) cellData.visible = true;
        else cellData.visible = false;
        if (cellData.columnPath.length === 0) cellData.visible = false;

        if (cellData.maxRowLevel > 1) cellData.visible = true;

        if (cellData.maxColumnLevel > 1 && cellData.columnPath.length === 1)
          cellData.visible = false;

        if (cellData.maxRowLevel > 1 && cellData.rowPath.length <= 1)
          cellData.visible = false;

        if (cellData.columnPathFormatted[0] === "Grand Total") {
          cellData.visible = false;
          // console.log("false 2");
        }

        if (cellData.maxRowLevel === 3 && cellData.rowPath.length !== 3) {
          cellData.visible = false;
          // console.log("false 1");
        }

        if (cellData.maxRowLevel === 3 && cellData.rowPath.length === 3) {
          cellData.visible = true;
          self.placeholderPegawaiSelectedPivot[0] = cellData.rowPath[0];
          self.placeholderPegawaiSelectedPivot[1] = cellData.rowPath[1];
          if (cellData.columnPath.length <= 1) cellData.visible = false;
        }

        if (cellData.maxRowLevel === 3 && cellData.rowPath.length === 2) {
          // cellData.visible = true;
          if (
            self.placeholderPegawaiSelectedPivot[0] === cellData.rowPath[0] &&
            self.placeholderPegawaiSelectedPivot[1] === cellData.rowPath[1]
          ) {
            cellData.visible = true;
          }
          if (cellData.columnPath.length <= 1) cellData.visible = false;
        }

        // if (cellData.maxRowLevel !== cellData.rowPath.length) {
        //   cellData.visible = false;
        //   console.log("maxRowLevel != rowPath");
        // }

        console.log(
          "cellData " + cellData.visible,
          cellData.rowPath,
          cellData.columnPath,
          cellData
        );
        // console.log("placeholder", self.placeholderPegawaiSelectedPivot);

        return cellData; // This line is optional
      },
    });

    console.log("pivotInstance", this.pivotInstance);

    // const pivotGrid = this.$refs.pivotDireksiRef;
    // console.log("element", pivotGrid);
    // console.log("expl", pivotGrid.dataSource);

    // const ds = pivotGrid.dataSource;
    // console.log("ds", ds);
    // console.log("instance datasource", instance.dataSource);
  },
  computed: {
    refreshButtonText() {
      return `Refresh Proyeksi Tahun ${this.tahunProyeksi}`;
    },
  },
  methods: {
    onShown() {
      setTimeout(() => {
        this.loadingVisible = false;
      }, 3000);
    },
    async refreshProyeksi() {
      notify("Memulai Proses Refresh Proyeksi Gaji....", "success");
      var instance = this.$refs.refPivot.instance;

      console.log("refreshProyeksi instance", instance);
      console.log(
        "refreshProyeksi instance getDataSource",
        instance.getDataSource()
      );

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      var data = {
        tahun: this.tahunProyeksi,
        gajiPeriodeData: this.gajiPeriodeData,
      };
      // const response = await axios.post(
      //   "http://127.0.0.1/api/refresh_proyeksi_gaji_practice",
      //   data,
      //   config
      // );

      // return response.data;
      this.loadingTitle = "Refresh Proyeksi Gaji...";
      this.loadingVisible = true;
      await axios
        .post(`${API_BASE_URL}/refresh_proyeksi_gaji_practice`, data, config)
        .then((response) => {
          console.log("Refresh Proyeksi Gaji Berhasil");
          notify("Refresh Proyeksi Gaji Berhasil", "success");
          console.log(response);
          this.fetchData();
          instance.getDataSource().reload();

          console.log("POPUPREFRESHALLGAJIVISIBLE FALSE");
          this.loadingVisible = false;
          this.popupRefreshAllGajiVisible = false;
          // window.location.reload();
          // this.fetchDataPerbandingan();
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal Refresh Proyeksi Gaji", "error");
          console.log("POPUPREFRESHALLGAJIVISIBLE FALSE");
          this.loadingVisible = false;
          this.popupRefreshAllGajiVisible = false;
        });
    },
    refreshProyeksiDialog() {
      console.log("refreshProyeksiDialog");
      this.refreshDialogVisible = true;
    },
    printKetJustOnce(index) {
      if (index == 0) return true;
      return false;
    },
    convertTglIndonesia(inputDate) {
      const parsedDate = DateTime.fromISO(inputDate);

      // Format the date in the desired Indonesian format
      const formattedDate = parsedDate.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return formattedDate;
    },

    printKet(ket, title) {
      let printPensiun = "<strong>PENSIUN:</strong> <ol>";
      let printKP = "<strong>KP:</strong> <ol>";
      let printKGB = "<strong>KGB:</strong> <ol>";
      console.log("KETERANGAN", title);

      if (ket.pensiun) {
        ket.pensiun.forEach((extracted) => {
          printPensiun =
            printPensiun +
            "<li><div class='highlight-ket'>" +
            extracted.nama +
            "</div> " +
            extracted.nik +
            " (" +
            this.convertTglIndonesia(extracted.pensiun_tgl) +
            ") </li>";
        });
      }

      if (ket.kgb) {
        ket.kgb.forEach((extracted) => {
          printKGB =
            printKGB +
            "<li><div class='highlight-ket'>" +
            extracted.pegawai.nama +
            "</div> " +
            extracted.pegawai.nik +
            " (" +
            this.convertTglIndonesia(extracted.tgl) +
            ", " +
            extracted.masa_kerja +
            " tahun)</li>";
        });
      }

      if (ket.kp) {
        ket.kp.forEach((extracted) => {
          console.log("KP", extracted.pegawai.nama, extracted.golongan.nama);
          printKP =
            printKP +
            "<li><div class='highlight-ket'>" +
            extracted.pegawai.nama +
            "</div> " +
            extracted.pegawai.nik +
            "  (" +
            this.convertTglIndonesia(extracted.tgl) +
            ", " +
            extracted.golongan.nama +
            ")</li>";
        });
      }

      return (
        printPensiun + "</ol><br>" + printKP + "</ol><br>" + printKGB + "</ol>"
      );
    },
    setDataStoreTetap() {
      console.log("setDataStoreTetap");
      this.dataSourceTetap = new PivotGridDataSource({
        // retrieveFields: false,
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            caption: "Pegawai",
            width: 120,
            dataField: "pegawai",
            area: "row",
          },
          {
            caption: "Komponen",
            width: 120,
            dataField: "komponen",
            area: "row",
          },
          // {
          //   dataField: "tgl",
          //   dataType: "date",
          //   area: "column",
          //   format: "MMM yyyy",
          // },

          {
            //For years
            dataField: "tgl",
            dataType: "date",
            groupInterval: "year",
            area: "column",
          },
          {
            //For Months
            dataField: "tgl",
            dataType: "date",
            groupInterval: "month",
            area: "column",
          },

          {
            caption: "Jml",
            dataType: "number",
            summaryType: "custom",
            calculateCustomSummary: this.calculateCustomSummary,
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeTetap,
      });
      console.log("dataSourceTetap", this.dataSourceTetap);
    },

    calculateCustomSummary(options) {
      // console.log("calculateSummaryType options", options);

      // you can check for specific row conditions

      // return default summary type for other rows
      switch (options.summaryProcess) {
        case "start":
          // console.log("calculateSummaryType start sebelum", options);
          options.totalValue = 0;
          // console.log("calculateSummaryType start setelah", options);
          break;
        case "calculate":
          if (options.value.tambahan) {
            options.totalValue += Number(options.value.jml);
          } else if (options.value.potongan) {
            // console.log("ada potongan ", options.value.komponen);
            options.totalValue = options.totalValue - Number(options.value.jml);
          }

          // if (options.value.isApproved) {
          //   options.totalValue.conditionalVal += options.value.amount;

          break;
        case "finalize":
          break;
      }
    },

    async fetchData() {
      console.log("fetchData");

      const response = await axios.get(
        `${API_BASE_URL}/get_proyeksi_gaji_practice`,
        {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        }
      );
      console.log("fetchData response", response.data[0]);

      this.storeTetap = response.data[0];
      this.setDataStoreTetap();
      console.log("fetchData storeTetap", this.storeTetap);
      return response.data[0];
    },

    async fetchDataPerbandingan() {
      this.loadingTitle = "Generate Tabel Perbandingan...";
      this.loadingVisible = true;

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      var data = {
        tahun_proyeksi: this.tahunProyeksi,
      };
      const response = await axios.post(
        `${API_BASE_URL}/proyeksi_gaji_perbandingan`,
        data,
        config
      );
      this.loadingVisible = false;
      this.storePerbandingan = response.data;
      return response.data;
    },

    customizeTooltip(arg) {
      console.log("arg", arg);
      return {
        text: `${arg.seriesName} ${arg.argument} : ${arg.valueText}`,
      };
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Proyeksi Gaji");

      exportPivotGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Proyeksi Gaji.xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
